// @flow

export const setTitle = (title: string = '') => {
  return { type: 'SET_TITLE', title };
}

export const clearTitle = () => {
  return { type: 'CLEAR_TITLE' };
}



// WEBPACK FOOTER //
// ./src/actions/common/navigation.js